import { useAuth } from '@/context/AuthContext';

/**
 * Hook to check if the current user has a premium account
 * @returns Object with isPremium boolean and account_type string
 */
export const usePremium = () => {
  const { user } = useAuth();

  // Check if user has premium account type
  // Premium account types: 'premium', 'pro'
  // Fallback to localStorage if user.account_type is not available
  const accountTypeFromUser = user?.account_type;
  const accountTypeFromStorage = localStorage.getItem('account_type');
  const accountType = accountTypeFromUser || accountTypeFromStorage;

  const premiumTypes = ['premium', 'pro'];
  const isPremium = accountType ? premiumTypes.includes(accountType.toLowerCase()) : false;

  return {
    isPremium,
    accountType: accountType || 'free'
  };
};
